import { createContextId } from "@builder.io/qwik";
const CheckboxContext = createContextId("CheckBox.context");
const CheckListContext = createContextId("CheckList.context");
export {
  CheckListContext,
  CheckboxContext
};
